import { initSmoothScroll } from "../modules/smooth-scroll.js";

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSmoothScroll, { once: true });
} else {
  initSmoothScroll();
}
